export const StyleSheet = {
  container: {
    border: "0px solid rgba(255, 255, 255, 1)",
    boxShadow: "0px 0px 20px rgba(0, 0, 0, .1)",
    borderRadius: "4px",
    backgroundColor: "white",
    display: "flex",
    padding: "16px",
    width: "300px",
    marginLeft: "5px",
  },
  codeBox: {
    width: "602px",
    height: "400px",
    borderRadius: "8px",
    marginBottom: "30px",
  },
  circle: {
    height: "56px",
    width: "56px",
    borderRadius: "50%",
  },
  circleBig: {
    height: "100px",
    width: "100px",
    borderRadius: "50%",
  },
  line: {
    width: "96px",
    height: "8px",
    alignSelf: "center",
    marginLeft: "16px",
    borderRadius: "8px",
  },
  messageMine: {
    padding: "16px 20px 16px 20px",
    marginBottom: "20px",
    width: "300px",
    maxWidth: "500px",
    borderRadius: "8px",
  },
  messageYours: {
    padding: "16px 20px 16px 20px",
    marginBottom: "20px",
    width: "300px",
    maxWidth: "500px",
    borderRadius: "8px",
    flex: "50%",
  },
  projectBox: {
    display: "flex",
    flexDirection: "column",
    borderRadius: "9.6px",
    width: "152.64px",
    height: "164px",
    padding: "6px",
    margin: "0 32px 28px 0",
  },
  publicEditor: {
    margin: "0 48px 40px 0",
    width: "600px",
    height: "400px",
    borderRadius: "8px",
  },
  comment: {
    width: "1028px",
    height: "100px",
    borderRadius: "18px",
    boxSizing: "border-box",
    marginBottom: "10px",
  },
};